class UnitController {
  constructor() {
    this.name = 'unit';
  }
}

export default UnitController;



// WEBPACK FOOTER //
// ./client/app/components/unit/unit.controller.js